import {InferGetStaticPropsType} from 'next';
import Image from 'next/legacy/image';
import Link from 'next/link';
import React from 'react';

import startedImage from '../../../public/img/startPage/startedImage.png';
import Col from '../../features/common/Col';
import Row from '../../features/common/Row';
import {getCmsEntry} from '../../features/strapi';
import {ApiStartpageStartpage} from '../../features/strapi/generated/contentTypes';
import Button from '../../features/tool/components/buttons/Button';
import GenericCard from '../../features/tool/components/GenericCard';
import {getToolLayout} from '../../features/tool/components/Layout';
import RichText from '../../features/tool/components/RichText';
import {buildStaticPropsResponse} from '../../features/tool/util/dataFetch';
import {Plant5LeavesIcon, PlantIcon} from '../../resources/Icons';
import URLS from '../../urls';
import {NextPageWithLayout} from '../_app';

const GetStarted: NextPageWithLayout<InferGetStaticPropsType<typeof getStaticProps>> = ({startpage}) => {
  return (
    <Row className="grow bg-primary-700 text-white">
      <Col className={'flex-1 justify-center'}>
        <Col className={'max-w-[62rem] mx-auto p-xs gap-sm'}>
          <h1 className="text-white font-semibold text-3xl">{startpage.title}</h1>
          {startpage.intro && <RichText content={startpage.intro} />}
          <Row className={'gap-sm text-sm [&_strong]:text-primary-300'}>
            <GenericCard border={'darkgreen'} className={'basis-0 grow p-sm gap-xs'}>
              <PlantIcon className={'text-primary-300'} />
              <RichText content={startpage.description_planning} />
            </GenericCard>
            <GenericCard border={'darkgreen'} className={'basis-0 grow p-sm gap-xs'}>
              <Plant5LeavesIcon className={'text-primary-300'} />
              <RichText content={startpage.description_supplier} />
            </GenericCard>
          </Row>
          <RichText content={startpage.body} />
          <Button className="w-fit mt-sm" variant="prominent" accessory="forward" href={URLS.startFlow}>
            <span className={'mr-sm'}>{startpage.button_title}</span>
          </Button>
          <Row className="text-sm gap-sm">
            <p>Already have an account?</p>
            <Link href={URLS.signin} className="no-underline hover:text-white text-primary-300">
              Log in
            </Link>
          </Row>
        </Col>
      </Col>
      <div className="flex-none relative w-2/6 mobile:hidden">
        <Image
          alt="Get started background image"
          src={startedImage}
          layout="fill"
          objectFit="cover"
          objectPosition="top center"
        />
      </div>
    </Row>
  );
};

export const getStaticProps = async () => {
  return buildStaticPropsResponse(
    await getCmsEntry<ApiStartpageStartpage, 'startpage'>({
      path: 'startpage',
      params: {populate: '*'},
      processDataMap: {
        body: 'markdown',
        intro: 'markdown',
        description_planning: 'markdown',
        description_supplier: 'markdown',
      },
    })
  );
};

export default GetStarted;

GetStarted.getLayout = getToolLayout;

GetStarted.title = 'Get started';
